export async function n(fieldId: string, placeholder: string, hasError: boolean, onChange: ((value: Number) => void)) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-splitbuttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { NumericTextBox } = await import('@syncfusion/ej2-inputs');

    const containerEle = document.getElementById('container_' + fieldId);
    const inputEle = document.getElementById('input_' + fieldId);

    if (containerEle.hasAttribute("data-numerictextbox")) {
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    containerEle.setAttribute('data-numerictextbox', 'true');

    let ddObject = new NumericTextBox({
        // sets the placeholder
        format: 'n0',
        floatLabelType: "Never",
        min: 0,
        step: 1,
        placeholder: null,
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            containerEle.style.display = null;
        },
        change: (args: any) => {
            onChange(args.value);
        }
    });
    ddObject.appendTo('#input_' + fieldId);
}